const config = {
  API_URL:  'https://ai.darjuv9.com/backend/',
  // API_URL:  'http://localhost:5000/',
  
};

export default config;